import { gql } from '@apollo/client';

export type ALL_ORGANISATION_METABASE_DASHBOARDSType = {
  data: {
    id: string;
    metabaseId: number;
    metabaseName: string;
    startDate: string | null;
    endDate: string | null;
    user: {
      id: string;
      firstName: string | null;
      lastName: string | null;
      email: string;
    };
  }[];
};

export const ALL_ORGANISATION_METABASE_DASHBOARDS = gql`
  query GetOrganizationMetabaseDashboards {
    data: getOrganizationMetabaseDashboards {
      id
      metabaseId
      metabaseName
      startDate
      endDate
      user {
        id
        firstName
        lastName
        email
      }
    }
  }
`;
